import { Box, Button, Tooltip } from "@mui/material";
import { useMemo, useState } from "react";
import AssetPreviewModal from "components/common/asset-preview-button/asset-preview-modal/AssetPreviewModal";
import React from "react";
import Asset from "datalign-module-template/models/asset";
import {
  CODE_EXTENSIONS,
  TEXT_EXTENSIONS,
} from "datalign-module-template/components/extensionsList";
import { GetFileExtension } from "datalign-module-template/helpers/GetFileExtension";

const AssetPreviewButton = ({ asset }: { asset: Asset }) => {
  const [openModal, setOpenModal] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [fileContent, setFileContent] = useState<
    string | ArrayBuffer | object | null
  >(null);
  const extension = useMemo(() => GetFileExtension(asset.name), [asset]);

  const handlePreview = async () => {
    setOpenModal(true);
    setFileContent("Empty file content.");
    try {
      setLoaded(false);
      const response = await fetch(asset.presigned_url, {
        method: "GET",
        headers: {
          "Content-Disposition": `attachment; filename="${asset.name}"`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the file.");
      }

      if (extension === ".pdf") {
        const arrayBuffer = await response.arrayBuffer();
        setFileContent(arrayBuffer);
      } else if ([".json", ".geojson"].includes(extension)) {
        const jsonObject = await response.json();
        setFileContent(jsonObject);
      } else if (
        TEXT_EXTENSIONS.includes(extension) ||
        CODE_EXTENSIONS.includes(extension)
      ) {
        const textContent = await response.text();
        setFileContent(textContent);
      } else {
        console.log("Unknown file type");
        setFileContent("Unsupported file type");
      }
    } catch (error) {
      console.error("Error loading file:", error);
      setFileContent("Error loading file.");
    } finally {
      setLoaded(true);
    }
  };

  return (
    <>
      <Tooltip title={asset.name}>
        <Button
          onClick={handlePreview}
          variant="contained"
          sx={{
            justifyContent: "flex-start",
            textTransform: "none",
            width: "auto",
            m: 1,
            maxWidth: "100%",
          }}
          fullWidth
        >
          <Box
            component="span"
            sx={{
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              textAlign: "left",
            }}
          >
            {asset.name}
          </Box>
        </Button>
      </Tooltip>

      <AssetPreviewModal
        asset={asset}
        open={openModal}
        onClose={() => setOpenModal(false)}
        fileContent={fileContent}
        loaded={loaded}
        extension={extension}
      />
    </>
  );
};

export default AssetPreviewButton;
